var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yk-placeholder"},[_c('el-alert',{attrs:{"type":"info","closable":false,"show-icon":"","title":"影控模块建设中","description":"该模块暂未开放，后续功能逐步接入。"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ca22b67","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/admin/views/Yingkong.vue
// module id = 199
// module chunks = 0